import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom'
import CheckInError from '../CheckInError';
import EarlyCheckIn from '../EarlyCheckIn';
import ConfirmIdentity from '../ConfirmIdentity';
import CustomerIdentification from '../CustomerIdentification';
import Payment from '../Payment';
import CreditCard from '../CreditCard';
import PrintKey from '../PrintKey';

const CheckInContent = ({earlyCheckInBookings, name, status, setStatus }) => {

  return (
    <Routes>
      <Route
        path={'early-check-in/:groupId'}
        element={
          <EarlyCheckIn
            earlyCheckInBookings={earlyCheckInBookings}
            status={status}
          />
        } 
      />
      <Route
        path={'confirm-identity/:groupId'}
        element={<ConfirmIdentity status={status}/>} 
      />
      <Route
        path={'customer-identification/:groupId'}
        element={<CustomerIdentification  status={status}/>} 
      />
      <Route
        path={'payment/:groupId'}
        element={<Payment status={status} setStatus={setStatus}/>} 
      />
      <Route
        path={'credit-card/:groupId'}
        element={<CreditCard status={status}  setStatus={setStatus}/>} 
      />
      <Route
        path={'print-key/:groupId'}
        element={<PrintKey name={name} status={status}/>} 
      />
      <Route
        path={':groupId'}
        element={<CheckInError />} 
      />
      <Route path="*" element={<Navigate to="/group-check-in/:groupId" replace/>} />
    </Routes>
  );
};

export default CheckInContent;